import { Box, Loader, VisuallyHidden } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';
import { useEffect } from 'react';

type InfiniteScrollSentinelProps = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
};

export function InfiniteScrollSentinel({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: InfiniteScrollSentinelProps) {
  const { ref, entry } = useIntersection({ threshold: 0 });

  useEffect(() => {
    if (entry?.isIntersecting && hasNextPage && !isFetchingNextPage) {
      onLoadMore();
    }
  }, [entry?.isIntersecting, hasNextPage, isFetchingNextPage, onLoadMore]);

  if (!hasNextPage && !isFetchingNextPage) {
    return null;
  }

  return (
    <Box
      ref={ref}
      role="status"
      aria-live="polite"
      py="sm"
      style={{ display: 'flex', justifyContent: 'center' }}
    >
      {isFetchingNextPage && (
        <>
          <Loader size="sm" />
          <VisuallyHidden>Loading more results…</VisuallyHidden>
        </>
      )}
    </Box>
  );
}
